import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const BIONIVID_LOGO =
  "https://nivilabs.bionivid.com/resources/images/assest.static.bionivid.white.svg";
export const BIONIVID_LOGO_GREEN =
  "https://nivilabs.bionivid.com/resources/images/assest.static.bionivid.green.svg";
export const NIVILABS_LOGO =
  "https://nivilabs.bionivid.com/resources/images/assest.static.nivilabs.png";
export const REGISTER_IMG =
  "https://nivilabs.bionivid.com/resources/images/assest.static.register.png";
export const LOGIN_IMG =
  "https://nivilabs.bionivid.com/resources/images/assest.static.login.png";
export const HELP_IMG =
  "https://nivilabs.bionivid.com/resources/images/assest.static.help.png";
